"use client";
import { useQuery } from "@tanstack/react-query";
import { getFaqs } from "@/lib/actions/admin-dashboard/faq/get/getFaqs";

export const useGetFaqs = () => {
  return useQuery({
    queryKey: ["faqs"],
    queryFn: getFaqs,
  });
};